<div class="hb-wrap" [class.container]="!preview" [class.hb-wrap--preview]="preview" *ngIf="shown as c">
  <div class="hb" role="region" aria-label="Store closure notice">
    <svg class="hb-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" stroke-width="2" />
      <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    </svg>

    <p class="hb-text">
      <strong class="hb-title">{{ c.title || 'Holiday hours' }}</strong>
      <span class="hb-message" *ngIf="c.message"> - {{ c.message }}</span>
    </p>

    <button type="button" class="hb-close" *ngIf="!preview" (click)="dismiss()" aria-label="Dismiss notice">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" />
      </svg>
    </button>
  </div>
</div>
